import React from 'react';
import classnames from 'classnames';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import classes from './item-skeleton.scss';
export const ItemSkeleton = () => {
  const isMobileView = isMobile();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, isMobileView && /*#__PURE__*/React.createElement("div", {
    className: classes.picture
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.logoAndDescription
  }, !isMobileView && /*#__PURE__*/React.createElement("div", {
    className: classes.picture
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.description
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol5, classes.big)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol5, classes.big)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol2, classes.empty, classes.big)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol8, classes.empty)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol3
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol5
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.priceSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol4
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol6, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol3
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol5, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol4
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol7, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol3
  }))), !isMobileView && /*#__PURE__*/React.createElement("div", {
    className: classes.bottomContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.control
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol1, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol1, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol3
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.phCol1, classes.empty)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.phCol2
  })))), isMobileView && /*#__PURE__*/React.createElement("div", {
    className: classes.fakeMobileItemControlSpace
  }));
};